var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

console.clear();

var $ = require("./lib/qsa");
var leaflet = require("leaflet");
var colors = require("./lib/helpers/colors");

var mapContainer = $.one(".map-container");
var map = new leaflet.map(mapContainer, {
  zoomSnap: 0.1,
  scrollWheelZoom: true,
});

map.focus = () => null;

leaflet
  .tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png")
  .addTo(map);

window.DATA.sort((a, b) => (a.toggle_flag < b.toggle_flag ? -1 : 1));

var when = (condition, result) => (condition ? result : "");

// order school layers
var layerGroups = "RANDOM ASD CHARTER MSCS".split(" ");
var z = 601;
var layers = {};
for (var type of layerGroups) {
  var pane = map.createPane(type);
  pane.style.zIndex = z++;
  var layer = new leaflet.LayerGroup({ pane: type });
  layer.addTo(map);
  layers[type] = layer;
}

// generate a list of merged coordinate sets
var points = {};
var idLookup = {};
for (var row of window.DATA) {
  var { SCHOOL_NAME, coords, UniqueID } = row;
  if (!coords) continue;
  row.option = $.one(`option[value="${UniqueID}"]`);
  idLookup[UniqueID] = coords;
  if (!points[coords]) points[coords] = { data: [] };
  points[coords].data.push(row);
}

var bounds = new leaflet.LatLngBounds();
for (var [key, meta] of Object.entries(points)) {
  var coords = key.split(",");
  bounds.extend(coords);
  var investment = meta.data.some(d => d.invest_flag == "ELIG_YES") ? "invested" : "";
  var consolidation = meta.data.some(d => d.consolidation_flag == "CONSOLIDATION") ? "consolidation" : "";

  var flags = meta.data.map((d) => d.toggle_flag);
  var topmost = flags.at(-1);
  var layer = topmost in layers ? layers[topmost] : layers.RANDOM;

  var flagStrings = {
    ELIG_NO: "is not slated",
    ELIG_YES: "is slated",
  };

  var marker = new leaflet.Marker(coords, {
    icon: new leaflet.DivIcon({
      iconSize: [8, 8],
      className: `school ${consolidation} ${investment} ${flags.join(" ")}`,
    }),
    pane: topmost
  });
  meta.layer = layer;
  marker.addTo(layer);
  meta.marker = marker;
  var tooltip = meta.data
    .map(
      (row) => `
    <b>${row.SCHOOL_NAME}</b> 
    <br>
    <em>${row.DISTRICT_NAME}</em> 
    <br><br>

    This school is <b>${row.invest_flag == "INELIG" ? "ineligible" : "eligible"}</b> for investments.
    ${row.invest_flag == "INELIG" ? "" : `It <b>${flagStrings[row.invest_flag]}</b> for investments currently.`}
    ${row.consolidation_flag == "CONSOLIDATION" ? `<br><br>This school is slated for consolidation.` : ""}
    ${when(row.capacity, `<br><br>
    The building has capacity for ${row.capacity.toLocaleString()} students and had ${row.enrollment.toLocaleString()} enrolled.
    `)}
    `).join("<hr>");
  marker.bindPopup(tooltip);
}
map.fitBounds(bounds);

var zoomControl = map.zoomControl;

map.on("popupopen", function () {
  map.removeControl(zoomControl);
});

map.on("popupclose", function () {
  map.addControl(zoomControl);
});

// toggle controls

var toggles = $.one(".toggle-container");
var filters = {
  all: (d) => true,
  eligYes: (d) => d.invest_flag.match(/ELIG_YES/i),
  consolidate: (d) => d.consolidation_flag.match(/CONSOLIDATION/i),
};

function onChange(e) {
  let filterType = e.target.value;
  let filter = filters[filterType];

  for (let { data, layer, marker } of Object.values(points)) {
    var passed = data.some(filter);
    for (var row of data) {
      row.option.toggleAttribute("hidden", !passed);
    }

    if (passed) {
      marker.addTo(layer);
    } else {
      marker.remove();
    }
  }
}

toggles.addEventListener("input", onChange);

$.one("#school-select").addEventListener("input", function(e) {
  var coords = idLookup[e.target.value];
  var meta = points[coords];
  if (!meta) return;
  meta.marker.openPopup();
});